// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Axios from 'axios'
import VueTheMask from 'vue-the-mask'
import VueLocalStorage from 'vue-ls'
import App from './App'
import router from './router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

var options = {
  namespace: 'autocar__'
}

Vue.use(VueMaterial)
Vue.config.productionTip = false
Vue.use(VueTheMask)
Vue.use(VueLocalStorage, options)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  render: h => h(App),
  created () {
    this.ValidateCredential()
  },
  computed: {
    firstDayOfAWeek: {
      get () {
        return this.$material.locale.firstDayOfAWeek
      },
      set (val) {
        this.$material.locale.firstDayOfAWeek = val
      }
    }
  },
  name: 'TableFixed',
  data: () => ({
    global: {
      // webApi: 'https://localhost:44331/',
      webApi: 'https://dswebapi.duesoft.com.br/',
      menuVisible: false,
      menuAcoesVisible: false,
      menuAcoesShow: false,
      sending: false,
      dialogVisible: false,
      dialogMessage: '',
      logged: false,
      recuperaSenhaVisible: false,
      alteraSenhaVisible: false,
      activeRoute: '',
      enterControl: '',
      schema: 'Autocar'
    },
    user: {
      cnpj: Vue.ls.get('usr'),
      name: Vue.ls.get('name'),
      password: null,
      newPassword: null,
      confirmNewPassword: null,
      company: Vue.ls.get('cpn'),
      auth: Vue.ls.get('cdt'),
      saved: false,
      logo: Vue.ls.get('logo'),
      email: null
    },
    home: {
      visible: false,
      acoesVisible: false
    },
    login: {
      visible: true,
      acoesVisible: false,
      companies: [],
      lastUser: null,
      validId: false
    },
    paginacao: {
      visible: false,
      pagina: 1,
      totalPaginas: 1
    },
    produtos: {
      visible: false,
      promocao: false,
      acoesVisible: true,
      itens: [],
      imagemPrincipal: null,
      detalhe: {
        menuTitle: 'Geral',
        item: null,
        visible: false
      },
      pesquisa: {
        visible: false,
        filtrados: [],
        codigoEmpresaOriginalSimilarSrc: null,
        descSrc: null,
        lancSrc: null
      }
    },
    produtosLanc: {
      showLanc: true,
      visible: false,
      acoesVisible: true,
      itens: [],
      imagemPrincipal: null,
      detalhe: {
        menuTitle: 'Geral',
        item: null,
        visible: false
      },
      pesquisa: {
        visible: false,
        filtrados: [],
        codigoEmpresaOriginalSimilarSrc: null,
        descSrc: null,
        lancSrc: null
      }
    },
    produtosPromocao: {
      visible: false,
      acoesVisible: true,
      itens: [],
      imagemPrincipal: null,
      detalhe: {
        menuTitle: 'Geral',
        item: null,
        visible: false
      },
      pesquisa: {
        visible: false,
        filtrados: [],
        codigoEmpresaOriginalSimilarSrc: null,
        descSrc: null,
        lancSrc: null
      }
    },
    carrinho: {
      visible: false,
      acoesVisible: true,
      inputQtd: {
        visible: false,
        item: { stock: 0.00 },
        qtd: 0.00
      },
      editQtd: {
        visible: false,
        item: { stock: 0.00 },
        qtd: 0.00
      },
      itens: [],
      detalhe: {
        visible: false,
        total: 0.00
      }
    },
    historicoFinanceiro: {
      visible: false,
      acoesVisible: true,
      itens: [],
      pesquisa: {
        visible: false,
        dtVencIni: null,
        dtVencFin: null,
        dtPicker1: 0,
        dtPicker2: 1
      }
    },
    pedidos: {
      visible: false,
      acoesVisible: true,
      pesquisa: {
        visible: false,
        initialDateSrc: null,
        finalDateSrc: null,
        statusSrc: [],
        status: []
      },
      itens: [],
      detalhe: {
        item: {
          company: null,
          solicitationNumber: null,
          orderNumber: null,
          status: null,
          orderDate: '',
          totalPrice: null,
          itens: []
        },
        visible: false
      }
    },
    fornecedores: {
      visible: false,
      acoesVisible: false,
      images: []
    },
    configuracoes: {
      visible: false,
      acoesVisible: false
    },
    update: {
      updating: false,
      produtosToUpdate: true,
      grayScreen: false
    }
  }),
  methods: {
    Logoff () {
      this.ClearCredential()
      this.GerenciarNavegacao('login')
    },
    MaskDateVenctoIni () {
      if (this.historicoFinanceiro.pesquisa.dtVencIni === null || this.historicoFinanceiro.pesquisa.dtVencIni === undefined) {
        return
      }

      while (this.historicoFinanceiro.pesquisa.dtVencIni.includes('/')) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.replace('/', '')
      }

      if (this.historicoFinanceiro.pesquisa.dtVencIni.length > 2) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.substring(0, 2) + '/' + this.historicoFinanceiro.pesquisa.dtVencIni.substring(2)
      }

      if (this.historicoFinanceiro.pesquisa.dtVencIni.length > 5) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.substring(0, 5) + '/' + this.historicoFinanceiro.pesquisa.dtVencIni.substring(5)
      }

      if (this.historicoFinanceiro.pesquisa.dtVencIni.length > 10) {
        this.historicoFinanceiro.pesquisa.dtVencIni = this.historicoFinanceiro.pesquisa.dtVencIni.substring(0, 10)
      }
    },
    MaskDateVenctoFin () {
      if (this.historicoFinanceiro.pesquisa.dtVencFin === null || this.historicoFinanceiro.pesquisa.dtVencFin === undefined) {
        return
      }

      while (this.historicoFinanceiro.pesquisa.dtVencFin.includes('/')) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.replace('/', '')
      }

      if (this.historicoFinanceiro.pesquisa.dtVencFin.length > 2) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.substring(0, 2) + '/' + this.historicoFinanceiro.pesquisa.dtVencFin.substring(2)
      }

      if (this.historicoFinanceiro.pesquisa.dtVencFin.length > 5) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.substring(0, 5) + '/' + this.historicoFinanceiro.pesquisa.dtVencFin.substring(5)
      }

      if (this.historicoFinanceiro.pesquisa.dtVencFin.length > 10) {
        this.historicoFinanceiro.pesquisa.dtVencFin = this.historicoFinanceiro.pesquisa.dtVencFin.substring(0, 10)
      }
    },
    ExibirDetalheProduto (produto) {
      this.produtos.detalhe.code = produto.code
      this.produtos.detalhe.productGroup = produto.productGroup
      this.produtos.detalhe.productSubgroup = produto.productSubgroup
      this.produtos.detalhe.description = produto.description
      this.produtos.detalhe.completeDescription = produto.completeDescription
      console.log(produto.completeDescription)
      this.produtos.detalhe.unity = produto.unity
      this.produtos.detalhe.stock = parseFloat(produto.stock.toFixed(6))
      this.produtos.detalhe.price = produto.price
      this.produtos.detalhe.observations = produto.observations
      this.produtos.detalhe.applications = produto.applications
      this.produtos.detalhe.originalCodes = produto.originalCodes
      this.produtos.detalhe.similar = produto.similar
      this.produtos.detalhe.images = produto.images
      this.produtos.detalhe.marcaPecaProduto = produto.marcaPecaProduto

      this.produtos.detalhe.visible = true
      this.update.updating = false
    },
    CloseInfoProd () {
      this.produtos.detalhe.visible = false
      this.update.updating = false
    },
    ShowDialog (message) {
      this.global.dialogMessage = message
      this.global.dialogVisible = true
    },
    GerenciarNavegacao (rota) {
      this.global.menuVisible = false
      this.global.menuAcoesVisible = false
      this.global.menuAcoesShow = false
      this.global.alteraSenhaVisible = false
      this.login.visible = false
      this.home.visible = false
      this.produtos.visible = false
      this.produtosLanc.visible = false
      this.historicoFinanceiro.visible = false
      this.carrinho.visible = false
      this.pedidos.visible = false
      this.fornecedores.visible = false
      this.configuracoes.visible = false
      this.paginacao.visible = false
      Vue.ls.set('activeRoute', rota)

      switch (rota) {
        case 'login':
          this.global.activeRoute = 'Catálogo Online'
          this.login.visible = true
          break

        case 'home':
          this.global.activeRoute = 'Início'
          this.global.menuAcoesVisible = this.home.acoesVisible
          this.home.visible = true
          break

        case 'produtos_lancamentos':
          this.global.activeRoute = 'Lançamentos'
          this.global.menuAcoesVisible = this.produtosLanc.acoesVisible
          this.CarregarTelaDeLancamentos()
          break

        case 'produtos':
          this.global.activeRoute = 'Produtos'
          this.global.menuAcoesVisible = this.produtos.acoesVisible
          this.LimparFiltrosPesquisaProdutos()
          this.CarregarTelaDeProdutos()
          break

        case 'produtos_promocao':
          this.global.activeRoute = 'Produtos Promoção'
          this.global.menuAcoesVisible = this.produtos.acoesVisible
          this.LimparFiltrosPesquisaProdutos()
          this.CarregarTelaDeProdutosPromocao()
          break

        case 'carrinho':
          this.global.activeRoute = 'Meu Carrinho'
          this.carrinho.itens = Vue.ls.get(this.user.company + '_carrinho')
          this.global.menuAcoesVisible = this.carrinho.acoesVisible
          this.carrinho.visible = true
          break

        case 'historico_financeiro':
          this.global.activeRoute = 'Relatório Financeiro'
          this.global.menuAcoesVisible = this.historicoFinanceiro.acoesVisible
          this.CarregarTelaDeHistoricoFinanceiro()
          break

        case 'pedidos':
          this.global.activeRoute = 'Meus Pedidos'
          this.global.menuAcoesVisible = this.pedidos.acoesVisible
          this.CarregarTelaDePedidos()
          break

        case 'fornecedores':
          this.global.activeRoute = 'Fornecedores'
          this.global.menuAcoesVisible = this.fornecedores.acoesVisible
          this.CarregarTelaDeFornecedores()
          break

        case 'configuracoes':
          this.global.activeRoute = 'Configurações'
          this.global.menuAcoesVisible = this.configuracoes.acoesVisible
          this.configuracoes.visible = true
          break

        default:
          this.global.activeRoute = 'Lançamentos'
          this.global.menuAcoesVisible = this.produtosLanc.acoesVisible
          this.CarregarTelaDeLancamentos()
          Vue.ls.set('activeRoute', 'produtos_lancamentos')
          this.global.activeRoute = 'Lançamentos'
      }
    },
    Redirecionar (rota) {
      this.global.menuVisible = false
      this.global.menuAcoesVisible = false
      this.global.menuAcoesShow = false
      this.login.visible = false
      this.home.visible = false
      this.produtos.visible = false
      this.produtosLanc.visible = false
      this.historicoFinanceiro.visible = false
      this.carrinho.visible = false
      this.pedidos.visible = false
      this.fornecedores.visible = false
      this.configuracoes.visible = false
      this.paginacao.visible = false
      Vue.ls.set('activeRoute', rota)

      switch (rota) {
        case 'produtos':
          this.global.activeRoute = 'Produtos'
          this.global.menuAcoesVisible = this.produtos.acoesVisible
          this.paginacao.visible = false
          this.produtos.visible = true
          this.paginacao.pagina = 1
          this.ExibirProdutos('<', false, false)
          this.update.updating = false
          break
      }
    },
    ObterEmpresas () {
      this.global.sending = true
      this.user.company = null
      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetCompanies?id=' + this.user.cnpj + '&schema=' + this.global.schema
      }).then(response => {
        if (response.status === 200) {
          this.login.companies = response.data
          this.login.validId = true
          this.global.sending = false
        } else {
          this.login.validId = false
          this.ShowDialog('Nenhuma empresa vinculada a esse CNPJ.')
          this.global.sending = false
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor!')
          this.global.sending = false
        })
    },
    EfetuarLogin () {
      this.global.sending = true

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/UserLogin',
        data: {
          User: this.user.cnpj,
          Password: this.user.password,
          Company: this.user.company,
          Schema: this.global.schema
        }
      }).then(response => {
        if (response.status === 200) {
          this.user.name = response.data.userName
          this.user.auth = response.data.authorization
          this.user.logo = response.data.logo
          this.logged = true
          this.saveUser()
          this.GerenciarNavegacao('produtos_lancamentos')
          this.global.sending = false
        } else {
          this.ClearCredential()
          this.GerenciarNavegacao('login')
          this.ShowDialog('Não foi possível efetuar a autenticação. Reveja seu login e senha ou entre em contato com seu fornecedor.')
          this.global.sending = false
        }
      })
        .catch(e => {
          this.ClearCredential()
          this.GerenciarNavegacao('login')
          this.ShowDialog('Não foi possível efetuar a autenticação. Reveja seu login e senha ou entre em contato com seu fornecedor.')
          this.global.sending = false
        })
    },
    CarregarTelaDeProdutos () {
      this.paginacao.visible = false
      this.produtos.visible = true
      this.produtos.promocao = false
      this.paginacao.pagina = 1
      this.ExibirProdutos('<', false, false)
      this.update.updating = false

      this.AbrirTelaDePesquisa()
    },
    CarregarTelaDeProdutosPromocao () {
      this.paginacao.visible = false
      this.produtos.visible = false
      this.produtos.promocao = true
      this.paginacao.pagina = 1
      this.ExibirProdutos('<', false, false)
      this.update.updating = false
    },
    CarregarTelaDeLancamentos () {
      this.produtosLanc.showLanc = true
      this.paginacao.visible = false
      this.produtosLanc.visible = true
      this.paginacao.pagina = 1
      this.ExibirProdutos('<', true, false)
      this.update.updating = false
    },
    CarregarTelaDeFornecedores () {
      this.global.sending = true
      this.fornecedores.visible = true

      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetSupliersLogos',
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.fornecedores.images = response.data.logos
          this.global.sending = false
        } else {
          this.ShowDialog('Não há imagens de fornecedores cadastradas.')
          this.global.sending = false
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.global.sending = false
        })
    },
    CarregarTelaDeHistoricoFinanceiro () {
      this.paginacao.visible = false
      this.historicoFinanceiro.visible = true
      this.paginacao.pagina = 1
      this.ExibirHistoricoFinanceiro('<')
      this.update.updating = false
    },
    ExibirHistoricoFinanceiro (direcao) {
      this.paginacao.visible = false

      if (direcao === '>') {
        this.paginacao.pagina++
      } else if (direcao === '<') {
        if (this.paginacao.pagina > 1) {
          this.paginacao.pagina--
        }
      }

      this.PesquisarHistoricoFinanceiro(false)
      this.paginacao.visible = true
    },
    PesquisarHistoricoFinanceiro (paginaInicial) {
      if (!this.IsLogged()) {
        return
      }

      this.historicoFinanceiro.pesquisa.visible = false
      this.update.updating = true

      if (paginaInicial) {
        this.paginacao.pagina = 1
      }

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificFinancialHistory',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          DataVencimentoInicial: this.historicoFinanceiro.pesquisa.dtVencIni,
          DataVencimentoFinal: this.historicoFinanceiro.pesquisa.dtVencFin,
          Pagina: this.paginacao.pagina
        }
      }).then(response => {
        if (response.status === 200) {
          this.historicoFinanceiro.itens = response.data.historico
          this.paginacao.totalPaginas = response.data.totalPaginas
          this.update.updating = false
        } else {
          this.update.updating = false
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Nenhum histórico financeiro foi encontrado.')
        }
      })
        .catch(e => {
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    CarregarTelaDePedidos () {
      this.pedidos.visible = true
      this.ObterPedidos()
      this.GetAllOrderStatus()
    },
    ObterPedidos () {
      if (!this.IsLogged()) {
        return
      }

      this.update.updating = true
      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetSummaryOrders',
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.pedidos.itens = response.data
          this.update.updating = false
        } else {
          this.update.updating = false
          this.ShowDialog('Nenhum pedido foi encontrado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.')
        }
      })
        .catch(e => {
          this.update.updating = false
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
        })
    },
    AbrirTelaDePesquisa () {
      this.LimparFiltrosPesquisaProdutos()
      this.global.menuAcoesShow = false
      this.produtos.pesquisa.visible = true
      this.update.grayScreen = true
    },
    AbrirTelaDePesquisaLancamento () {
      this.LimparFiltrosPesquisaProdutosLancamento()
      this.produtosLanc.showLanc = false
      this.global.menuAcoesShow = false
      this.produtosLanc.pesquisa.visible = true
      this.update.grayScreen = true
    },
    AbrirTelaDePesquisaHistoricoFinanceiro () {
      this.global.menuAcoesShow = false
      this.historicoFinanceiro.pesquisa.visible = true
      this.update.grayScreen = true
    },
    PesquisarProdutos (paginaInicial) {
      if (!this.IsLogged()) {
        return
      }

      this.produtos.pesquisa.visible = false
      this.update.updating = true

      if (paginaInicial) {
        this.paginacao.pagina = 1
      }
      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificProducts',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          Code: this.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc,
          Release: this.produtos.pesquisa.lancSrc,
          Description: this.produtos.pesquisa.descSrc,
          Page: this.paginacao.pagina,
          PromocaoSomenteCatalogo: false
        }
      }).then(response => {
        if (response.status === 200) {
          this.produtos.itens = response.data.produtos
          this.paginacao.totalPaginas = response.data.totalPaginas
          this.update.updating = false
          this.paginacao.visible = true
        } else {
          this.update.updating = false
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Nenhum produto foi encontrado.')
        }
      })
        .catch(e => {
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    PesquisarProdutosPromocao (paginaInicial) {
      if (!this.IsLogged()) {
        return
      }

      this.produtos.pesquisa.visible = false
      this.update.updating = true

      if (paginaInicial) {
        this.paginacao.pagina = 1
      }

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificProducts',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          Code: this.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc,
          Release: this.produtos.pesquisa.lancSrc,
          Description: this.produtos.pesquisa.descSrc,
          Page: this.paginacao.pagina,
          PromocaoSomenteCatalogo: true
        }
      }).then(response => {
        if (response.status === 200) {
          this.produtos.itens = response.data.produtos
          this.paginacao.totalPaginas = response.data.totalPaginas
          this.update.updating = false
          this.paginacao.visible = true
        } else {
          this.update.updating = false
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Nenhum produto foi encontrado.')
        }
      })
        .catch(e => {
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    TimeOutPesquisarProdutosLancamento () {
      setTimeout(() => {
        this.PesquisarProdutosLancamento(true)
      }, 150)
    },
    TimeOutPesquisarProdutos () {
      setTimeout(() => {
        this.PesquisarProdutos(true)
      }, 150)
    },
    TimeOutPesquisarProdutosPromocao () {
      setTimeout(() => {
        this.PesquisarProdutos(true)
      }, 150)
    },
    PesquisarProdutosLancamento (paginaInicial) {
      if (!this.IsLogged()) {
        return
      }

      this.produtosLanc.pesquisa.visible = false
      this.update.updating = true

      if (paginaInicial) {
        this.paginacao.pagina = 1
      }

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/GetSpecificProducts',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          Code: this.produtosLanc.pesquisa.codigoEmpresaOriginalSimilarSrc,
          Release: this.produtosLanc.pesquisa.lancSrc,
          Description: this.produtosLanc.pesquisa.descSrc,
          Page: this.paginacao.pagina
        }
      }).then(response => {
        if (response.status === 200) {
          this.produtosLanc.itens = response.data.produtos
          this.paginacao.totalPaginas = response.data.totalPaginas
          this.update.updating = false
          this.paginacao.visible = true
        } else {
          this.update.updating = false
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Nenhum produto foi encontrado.')
        }
      })
        .catch(e => {
          if (this.paginacao.pagina > 1) {
            this.paginacao.pagina--
          }
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    ObterLancamentos () {
      if (!this.IsLogged()) {
        return
      }

      this.produtosLanc.pesquisa.visible = false
      this.update.updating = true

      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetSummaryNewProducts?id=' + this.paginacao.pagina,
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.produtosLanc.itens = response.data.produtos
          this.paginacao.totalPaginas = response.data.totalPaginas
          this.update.updating = false
          this.paginacao.visible = true
        } else {
          this.update.updating = false
          this.ShowDialog('Nenhum produto foi encontrado.')
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    LimparFiltrosPesquisaProdutos () {
      this.produtos.pesquisa.codigoEmpresaOriginalSimilarSrc = ''
      this.produtos.pesquisa.descSrc = ''
      this.produtos.pesquisa.lancSrc = null
      this.global.enterControl = ''
    },
    LimparFiltrosPesquisaProdutosLancamento () {
      this.produtosLanc.pesquisa.codigoEmpresaOriginalSimilarSrc = ''
      this.produtosLanc.pesquisa.descSrc = ''
      this.produtosLanc.pesquisa.lancSrc = null
      this.global.enterControl = ''
    },
    GetProdInfo (prodSel) {
      if (!this.IsLogged()) {
        return
      }
      this.produtos.detalhe.visible = false
      this.update.updating = true
      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetProductInfo?id=' + prodSel.id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.ExibirDetalheProduto(response.data)
        } else {
          this.ShowDialog('Nenhum produto foi encontrado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.')
        }
        this.update.updating = false
      })
        .catch(e => {
          this.update.updating = false
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
        })
    },
    ExibirProdutos (direcao, lancamento, paginaInicial) {
      this.paginacao.visible = false

      if (direcao === '>') {
        if (this.paginacao.pagina !== this.paginacao.totalPaginas) {
          this.paginacao.pagina++
        }
      } else if (direcao === '<') {
        if (this.paginacao.pagina > 1) {
          this.paginacao.pagina--
        }
      }

      if (lancamento) {
        if (this.produtosLanc.showLanc) {
          this.ObterLancamentos()
        } else {
          this.PesquisarProdutosLancamento(paginaInicial)
        }
      } else {
        if (this.produtos.promocao) {
          this.PesquisarProdutosPromocao(paginaInicial)
        } else {
          this.PesquisarProdutos(paginaInicial)
        }
      }

      window.scrollTo(0, 0)
    },
    clearForm () {
      this.user.password = null
      this.user.newPassword = null
      this.user.confirmNewPassword = null
    },
    saveUser () {
      Vue.ls.set('usr', this.user.cnpj)
      Vue.ls.set('cpn', this.user.company)
      Vue.ls.set('cdt', this.user.auth)
      Vue.ls.set('logo', this.user.logo)
      Vue.ls.set('name', this.user.name)
      this.userSaved = true
      this.clearForm()
    },
    validateUser () {
      if (!this.user.cnpj !== undefined && !this.user.cnpj !== null && !this.user.cnpj !== '') {
        this.ObterEmpresas()
      }
    },
    validateLogin () {
      if (this.user.company !== null &&
          this.user.company !== undefined &&
          this.user.company.length > 0) {
        this.EfetuarLogin()
      }
    },
    fecharPesquisaProduto () {
      this.produtos.pesquisa.visible = false
      this.update.grayScreen = false
    },
    fecharPesquisaProdutoLancamento () {
      this.produtosLanc.pesquisa.visible = false
      this.update.grayScreen = false
    },
    FecharPesquisaHistoricoFinanceiro () {
      this.historicoFinanceiro.pesquisa.visible = false
      this.update.grayScreen = false
    },
    ClearCredential () {
      this.clearForm()
    },
    ValidateCredential () {
      this.update.updating = true
      this.user.cnpj = Vue.ls.get('usr')

      if (this.user.cnpj !== undefined && this.user.cnpj !== null && this.user.cnpj !== '') {
        this.user.company = Vue.ls.get('cpn')
        this.user.auth = Vue.ls.get('cdt')

        Axios({
          method: 'get',
          url: this.global.webApi + 'api/DSCOP/ValidateToken',
          headers: {
            Authorization: this.user.auth
          }
        }).then(response => {
          if (response.status === 200) {
            if (response.data === true) {
              this.logged = true
              this.GerenciarNavegacao(Vue.ls.get('activeRoute'))
            } else {
              this.EfetuarLogin()
            }
            this.update.updating = false
          } else {
            this.ClearCredential()
            this.GerenciarNavegacao('login')
            this.ShowDialog('Sua sessão expirou, efetue o login novamente!')
            this.update.updating = false
          }
        })
          .catch(e => {
            this.ClearCredential()
            this.GerenciarNavegacao('login')
            this.ShowDialog('Sua sessão expirou, efetue o login novamente!')
            this.update.updating = false
          })
      } else {
        this.GerenciarNavegacao('login')
        this.update.updating = false
      }
    },
    AddProd (item) {
      if (!this.IsLogged()) {
        return
      }
      this.update.updating = true
      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetProductInfo?id=' + item.id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.carrinho.inputQtd.item = response.data
          this.update.updating = false
          this.carrinho.inputQtd.visible = true
        } else {
          this.update.updating = false
          this.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.')
        }
      })
        .catch(e => {
          this.update.updating = false
          this.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.')
        })
    },
    ConfirmAddProd () {
      // Validar quantidade
      if (isNaN(this.carrinho.inputQtd.qtd)) {
        this.ShowDialog('Valor de quantidade informado é inválido!')
        return
      }

      if (this.carrinho.inputQtd.qtd < 0 || this.carrinho.inputQtd.qtd > this.carrinho.inputQtd.item.stock) {
        this.ShowDialog('Valor informado não disponível para o produto!')
        return
      }

      // Se não existir, adicionar ao carrinho
      if (this.carrinho.itens === undefined || this.carrinho.itens === null || this.carrinho.itens.length === 0) {
        this.carrinho.itens = [{
          id: this.carrinho.inputQtd.item.id,
          image: this.carrinho.inputQtd.item.image,
          code: this.carrinho.inputQtd.item.code,
          productGroup: this.carrinho.inputQtd.item.productGroup,
          description: this.carrinho.inputQtd.item.description,
          qtd: 0.000000,
          appQtd: parseFloat(this.carrinho.inputQtd.qtd.toFixed(6)),
          unity: this.carrinho.inputQtd.item.unity,
          price: 0.00,
          appPrice: this.carrinho.inputQtd.item.price,
          totalprice: 0.00,
          appTotalPrice: parseFloat((this.carrinho.inputQtd.qtd * this.carrinho.inputQtd.item.price.replace(',', '.')).toFixed(2))
        }]
      } else {
        // Verificar se já existe no carrinho
        // Se já existir exibir a mensagem para alterar na tela do carrinho
        var exist = this.carrinho.itens.filter(item => item.id === this.carrinho.inputQtd.item.id)
        if (exist !== undefined && exist !== null && exist.length > 0) {
          this.ShowDialog('Item já adicionado no carrinho, para editar a quantidade vá até a página do carrinho!')
          return
        }

        this.carrinho.itens.push({
          id: this.carrinho.inputQtd.item.id,
          image: this.carrinho.inputQtd.item.image,
          code: this.carrinho.inputQtd.item.code,
          productGroup: this.carrinho.inputQtd.item.productGroup,
          description: this.carrinho.inputQtd.item.description,
          qtd: 0.000000,
          appQtd: parseFloat(this.carrinho.inputQtd.qtd.toFixed(6)),
          unity: this.carrinho.inputQtd.item.unity,
          price: 0.00,
          appPrice: this.carrinho.inputQtd.item.price,
          totalPrice: 0.00,
          appTotalPrice: parseFloat((this.carrinho.inputQtd.qtd * this.carrinho.inputQtd.item.price.replace(',', '.')).toFixed(2))
        })
      }

      Vue.ls.set(this.user.company + '_carrinho', this.carrinho.itens)

      this.carrinho.inputQtd.item = { stock: 0.00 }
      this.carrinho.inputQtd.qtd = 0.00
      this.carrinho.inputQtd.visible = false

      this.SumShoppingCart()
    },
    CancelAddProd () {
      this.carrinho.inputQtd.item = { stock: 0.00 }
      this.carrinho.inputQtd.qtd = 0.00
      this.carrinho.inputQtd.visible = false

      this.SumShoppingCart()
    },
    EditProd (item) {
      if (!this.IsLogged()) {
        return
      }

      this.update.updating = true
      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetProductInfo?id=' + item.id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.carrinho.editQtd.item = response.data
          this.update.updating = false
          this.carrinho.editQtd.visible = true
        } else {
          this.update.updating = false
          this.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.')
        }
      })
        .catch(e => {
          this.update.updating = false
          this.ShowDialog('Não foi possível carregar os dados do produtos selecionado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.')
        })
    },
    ConfirmEditProd () {
      // Validar quantidade
      if (isNaN(this.carrinho.editQtd.qtd)) {
        this.ShowDialog('Valor de quantidade informado é inválido!')
        return
      }

      if (this.carrinho.editQtd.qtd < 0 || this.carrinho.editQtd.qtd > this.carrinho.editQtd.item.stock) {
        this.ShowDialog('Valor informado não disponível para o produto!')
        return
      }

      if (this.carrinho.editQtd.qtd === 0) {
        this.carrinho.itens = this.carrinho.itens.filter(x => x.id !== this.carrinho.editQtd.item.id)
      } else {
        // Verificar se já existe no carrinho
        // Se já existir exibir a mensagem para alterar na tela do carrinho
        this.carrinho.itens.forEach(element => {
          if (element.id === this.carrinho.editQtd.item.id) {
            element.code = this.carrinho.editQtd.item.code
            element.productGroup = this.carrinho.editQtd.item.productGroup
            element.description = this.carrinho.editQtd.item.description
            element.qtd = 0.000000
            element.appQtd = parseFloat(this.carrinho.editQtd.qtd.toFixed(6))
            element.unity = this.carrinho.editQtd.item.unity
            element.price = 0.00
            element.appPrice = this.carrinho.editQtd.item.price
            element.totalprice = 0.00
            element.appTotalprice = parseFloat((this.carrinho.editQtd.qtd * parseFloat(this.carrinho.editQtd.item.price)).toFixed(2))
          }
        })
      }

      Vue.ls.set(this.user.company + '_carrinho', this.carrinho.itens)

      this.carrinho.editQtd.item = { stock: 0.00 }
      this.carrinho.editQtd.qtd = 0.00
      this.carrinho.editQtd.visible = false

      this.SumShoppingCart()
    },
    CancelEditProd () {
      this.carrinho.editQtd.item = { stock: 0.00 }
      this.carrinho.editQtd.qtd = 0.00
      this.carrinho.editQtd.visible = false

      this.SumShoppingCart()
    },
    DeleteProd (item) {
      this.carrinho.itens = this.carrinho.itens.filter(x => x.id !== item.id)
      Vue.ls.set(this.user.company + '_carrinho', this.carrinho.itens)
      this.SumShoppingCart()
    },
    AbrirDetalhesCarrinho () {
      this.global.menuAcoesShow = false
      if (this.carrinho.itens !== undefined && this.carrinho.itens !== null && this.carrinho.itens.length > 0) {
        this.SumShoppingCart()
        this.carrinho.detalhe.visible = true
      } else {
        this.ShowDialog('Não há itens no seu carrinho.')
      }
    },
    CloseInfoCarrinho () {
      this.carrinho.detalhe.visible = false
    },
    SumShoppingCart () {
      this.carrinho.detalhe.total = 0.00
      this.carrinho.itens.forEach(element => {
        var _price = element.appPrice.replace(',', '.')
        var _qtd = element.appQtd
        var _total = _price * _qtd
        element.appTotalPrice = _total
        this.carrinho.detalhe.total = this.carrinho.detalhe.total + element.appTotalPrice
      })
      this.carrinho.detalhe.total = parseFloat(this.carrinho.detalhe.total.toFixed(2))
      this.carrinho.detalhe.total += ''
      this.carrinho.detalhe.total.replace('.', ',')
    },
    SendOrder () {
      if (!this.IsLogged()) {
        return
      }
      this.carrinho.detalhe.visible = false
      this.update.updating = true

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/SendOrder',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          itens: this.carrinho.itens
        }
      }).then(response => {
        if (response.status === 200) {
          this.ShowDialog('Pedido enviado com sucesso. Você será notificado assim que o pedido for avaliado.')
          this.LimparCarrinho()
          this.update.updating = false
        } else {
          this.ShowDialog('Não foi possível enviar o pedido. Entre em contato com seu fornecedor.')
          this.update.updating = false
          this.carrinho.detalhe.visible = true
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
          this.carrinho.detalhe.visible = true
        })
    },
    LimparCarrinho () {
      this.carrinho.itens = []
      Vue.ls.set(this.user.company + '_carrinho', [])
    },
    GetOrderInfo (item) {
      if (!this.IsLogged()) {
        return
      }

      this.update.updating = true
      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetOrderInfo?id=' + item.solicitationNumber,
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.pedidos.detalhe.item = response.data
          this.pedidos.detalhe.visible = true
          this.update.updating = false
        } else {
          this.ShowDialog('Nenhum pedido foi encontrado. Verifique sua conexão de internet ou entre em contato com seu fornecedor.')
          this.update.updating = false
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    CloseOrderInfo (item) {
      this.pedidos.detalhe.visible = false
    },
    CancelOrder (item) {
      this.CloseOrderInfo()

      if (!this.IsLogged()) {
        return
      }

      this.update.updating = true
      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/CancelOrder?order=' + item.solicitationNumber,
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.ShowDialog(response.data)
          this.ObterPedidos()
          this.update.updating = false
        } else {
          this.ShowDialog('Não foi possível cancelar o pedido. Entre em contato com seu fornecedor.')
          this.update.updating = false
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    OpenOrderSearch () {
      this.global.menuAcoesShow = false
      this.pedidos.pesquisa.visible = true
    },
    GetAllOrderStatus () {
      if (!this.IsLogged()) {
        return
      }

      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetAllOrderStatus',
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          this.pedidos.pesquisa.status = response.data
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
        })
    },
    SearchOrders () {
      if (!this.IsLogged()) {
        return
      }

      this.pedidos.pesquisa.visible = false
      this.update.updating = true

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/SearchOrders',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          InitialDate: this.pedidos.pesquisa.initialDateSrc,
          FinalDate: this.pedidos.pesquisa.finalDateSrc,
          Status: this.pedidos.pesquisa.statusSrc
        }
      }).then(response => {
        if (response.status === 200) {
          this.pedidos.itens = response.data
          this.update.updating = false
        } else {
          this.ShowDialog('Nenhum pedido foi encontrado.')
          this.update.updating = false
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    BuscarHistorioFinanceiro () {
      if (!this.IsLogged()) {
        return
      }

      this.pedidos.pesquisa.visible = false
      this.update.updating = true

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/SearchOrders',
        headers: {
          Authorization: this.user.auth
        },
        data: {
          InitialDate: this.pedidos.pesquisa.initialDateSrc,
          FinalDate: this.pedidos.pesquisa.finalDateSrc,
          Status: this.pedidos.pesquisa.statusSrc
        }
      }).then(response => {
        if (response.status === 200) {
          this.pedidos.itens = response.data
          this.update.updating = false
        } else {
          this.ShowDialog('Nenhum pedido foi encontrado.')
          this.update.updating = false
        }
      })
        .catch(e => {
          this.ShowDialog('Ocorreu um erro ao efetuar uma requisição de dados. Entre em contato com seu fornecedor.')
          this.update.updating = false
        })
    },
    CloseOrderSearch () {
      this.pedidos.pesquisa.visible = false
    },
    GetImage (id) {
      if (!this.IsLogged()) {
        return
      }

      Axios({
        method: 'get',
        url: this.global.webApi + 'api/DSCOP/GetMainImage?id=' + id,
        headers: {
          Authorization: this.user.auth
        }
      }).then(response => {
        if (response.status === 200) {
          if (response.data !== 0) {
            document.getElementById(id).src = response.data
          } else {
            document.getElementById(id).src = './static/img/0.0ef68e7.jpg'
          }
        }
      })
        .catch(e => {
          document.getElementById(id).src = './static/img/0.0ef68e7.jpg'
        })
    },
    IsLogged () {
      return this.logged
    },
    ObterUltimaData () {
      var data = Vue.ls.get(this.user.company + '_ultDt')

      if (data !== undefined && data !== null) {
        return data
      } else {
        return '01/01/1900'
      }
    },
    AtualizarUltimaData () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1 // January is 0!
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = dd + '/' + mm + '/' + yyyy

      Vue.ls.set(this.user.company + '_ultDt', today)
    },
    ArrayUniqueItem (array) {
      var a = array.concat()
      for (var i = 0; i < a.length; ++i) {
        for (var j = i + 1; j < a.length; ++j) {
          if (a[i].id === a[j].id) {
            a.splice(j--, 1)
          }
        }
      }
      return a
    },
    AddQtd1 () {
      this.carrinho.inputQtd.qtd = this.carrinho.inputQtd.qtd + this.carrinho.inputQtd.item.unitiesOnPackage
    },
    RmvQtd1 () {
      this.carrinho.inputQtd.qtd = this.carrinho.inputQtd.qtd - this.carrinho.inputQtd.item.unitiesOnPackage
    },
    AddQtd2 () {
      this.carrinho.editQtd.qtd = this.carrinho.editQtd.qtd + this.carrinho.editQtd.item.unitiesOnPackage
    },
    RmvQtd2 () {
      this.carrinho.editQtd.qtd = this.carrinho.editQtd.qtd - this.carrinho.editQtd.item.unitiesOnPackage
    },
    Fixed (value, precision) {
      return Number(value).toFixed(precision)
    },
    AbrirTelaRecuperacaoSenha () {
      this.global.recuperaSenhaVisible = true
    },
    RecuperarSenha () {
      this.global.recuperaSenhaVisible = false
      this.global.sending = true

      Axios({
        method: 'post',
        url: this.global.webApi + 'api/DSCOP/RecoverPassword',
        data: {
          User: this.user.cnpj,
          Email: this.user.email,
          Company: this.user.company,
          Schema: this.global.schema
        }
      }).then(response => {
        if (response.status === 200) {
          this.ShowDialog('Uma nova senha foi criada e enviada no seu email!')
        } else {
          this.ShowDialog('Não foi possível recuperar sua senha. Verifique o email de recuperação cadastrado com a loja!')
        }
        this.global.sending = false
      })
        .catch(e => {
          this.ShowDialog('Não foi possível recuperar sua senha. Verifique o email de recuperação cadastrado com a loja!')
          this.global.sending = false
        })
    },
    AbrirTelaAlteracaoSenha () {
      this.global.menuVisible = false
      this.global.alteraSenhaVisible = true
    },
    AlterarSenha () {
      this.update.updating = true

      if (this.user.newPassword === this.user.confirmNewPassword) {
        Axios({
          method: 'post',
          url: this.global.webApi + 'api/DSCOP/ChangePassword',
          headers: {
            Authorization: this.user.auth
          },
          data: {
            OldPassword: this.user.password,
            NewPassword: this.user.newPassword,
            ConfirmNewPassword: this.user.confirmNewPassword
          }
        }).then(response => {
          if (response.status === 200) {
            this.clearForm()
            this.ShowDialog('Senha alterada com sucesso!')
          } else {
            this.ShowDialog('Não foi possível alterar sua senha. Entre em contato com a loja!')
          }
          this.update.updating = false
        })
          .catch(e => {
            this.ShowDialog('Não foi possível alterar sua senha. Entre em contato com a loja!')
            this.update.updating = false
          })
        this.global.alteraSenhaVisible = false
      } else {
        this.ShowDialog('Nova senha diferente da senha de confirmação!')
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js